// extracted by mini-css-extract-plugin
module.exports = {"ModalContent":"ConfirmRequestSentModal_ModalContent__b0Xu5","Button":"ConfirmRequestSentModal_Button__3pJ92"};